var map = {
	"./1-0_Exploration.mp4": "549e",
	"./1A_DrillholeDesign.mp4": "27b1",
	"./1B_ExplorationDrilling.mp4": "5465",
	"./1C_ResourceModel.mp4": "095d",
	"./1D_RockCharacterization.mp4": "1074",
	"./Planning_0.0_to_2.0.mp4": "3eef",
	"./Planning_2.0_to_2A.mp4": "9738",
	"./journey-2.mp4": "b641",
	"./journey1-0.mp4": "4e4c",
	"./journey1-A.mp4": "6722",
	"./journey1-B.mp4": "1699",
	"./journey1-C.mp4": "22de",
	"./journey1-D.mp4": "c4c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a938";